import { useEffect, useRef, useState, useParams, useDropzone } from '../../common/common';
import * as XLSX from 'xlsx';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { validateAddProductVariantForm, validateAddSubCategoryForm } from '../../validation/Authentication/Validation.js';
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import useGetUserData from '../../secureAPI/GetUserData';
import { validateAddProductDetailsForm } from '../../validation/Authentication/Validation';
import { FiDownload, FiTrash2, FiFile, FiImage, FiFileText } from 'react-icons/fi';
import { FaFilePdf, FaFileWord, FaFilePowerpoint } from 'react-icons/fa';
const MidEditProducts = () => {

    // Basic States
    const { id } = useParams();

    const { setValidationError, clearAllErrors } = useErrorContext();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [uniqueID, setUniqueID] = useState(id);
        const [measurementdata, setmeasurementData] = useState([]);

    const [offerOpen, setOfferOpen] = useState(false);

    const handleOfferModalClose = () => setOfferOpen(false);
    // Product Details States
    const [badges, setBadges] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    const [selectedBadge, setSelectedBadge] = useState();
    const [selectedwarehouse, setSelectedwarehouse] = useState();
    const [productDetailsmodalShow, setproductDetailsmodalshow] = useState(false);
    const [shippingMeasurement, setShippingMeasurement] = useState(null);
    const [sellingMeasurment , setSellingMeasurment]=useState(null);


    const [values, setValues] = useState(
        {
            productName: '',
            productCode: '',
            productTax: '',
            shortDescription: '',
            badge: 0,
            warehouse: 0,
            warehouseName: '',
            badgeName: ''
        }
    );

    // product Category states 
    const [productcategoryString, setProductcategoryString] = useState();
    const [productCategorymodalShow, setproductCategorymodalshow] = useState(false);
    const [categories, setCategories] = useState([]); // Store all categories
    const [selectedCategories, setSelectedCategories] = useState([]); // Store selected categories dynamically
    const [categoryData, setCategoryData] = useState({}); // Store dynamic data for each select box


    // Product Variant States
    const [variantCount, setvariantCount] = useState(0);
    const [isVariantVisible, setIsVariantVisible] = useState(false);
    const [isVariantActive, setIsVariantActive] = useState(false);
    const [variantrowid, setEditvariantrowid] = useState(0);

    const [variationmodalShow, setVariationmodalshow] = useState(false);
    const [userAttributesarray, setUserAttributesArray] = useState([]);

    const [packingtype, setPackingtype] = useState(false);
    const [packingtypeSelected, setPackingtypeSelected] = useState('');
    const [measurementinputValue, setMeasurementInputValue] = useState('');
    const [packingtypedata, setPackingtypeData] = useState([]);
    const [packingtypeinputValue, setPackingtypeInputValue] = useState('');

    const [shippingpackingtype, setShippingPackingtype] = useState(false);
    const [shippingpackingtypeSelected, setShippingPackingtypeSelected] = useState('');
    const [shippingmeasurementinputValue, setShippingMeasurementInputValue] = useState('');
    const [productEditVariantmodalShow, setproductEditVariantmodalshow] = useState(false);


    const [disabledStatus, setDisabledStatus] = useState({
        productDetails: true,
        productCategories: true,
        productVariant: true,
        productPhoto: true,
        productDocument: true,
        productOffers: true,
        productShortDescription: true,
        productLongDescription: true,
    })



    const [variants, setVariants] = useState([])
    const [variantvalues, setVariantValue] = useState(
        {
            id: 0,
            sellingUnit: "",
            measurement: 0,
            shippingmeasurement: 0,
            sellingUnitPackingType: "",
            ShippingUnit: "",
            shippingUnitPackingType: "",
            productVariant: "",
            productHSN: "",
            productWarenty: "",
            productOU: "",
            productMOQ: "",
            productID: "",
            productMRP: "",
            productPrice: "",
            Link: "",
            Stock: "",
            fileImage: "",
            visible: 0,
            active: 0,
        }
    );
    const [editingVariant, setEditingVariant] = useState(null);
    const [variantImage, setVariantImage] = useState({
        file: null,       // For new file uploads
        preview: null,    // For preview of new uploads
        existing: null    // For existing images from server
    });

    const [documents, setDocuments] = useState([]);
    const [offersData, setOffresData] = useState([]);
    // ........................................All UseEffects..................................................
    useEffect(() => {
        getProductDetails();
        // getCategories(0);
    }, [uniqueID]);
    // useEffect(() => {
    //     getProductDetails();
    //     // GetproductVariants();
    //     // Getproductimages();
    //     // Getproductoffers();

    // }, []);
    useEffect(() => {
        if (variantvalues.productPhoto) {
            setVariantImage({
                file: null,
                preview: null,
                existing: variantvalues.productPhoto
            });
        }
    }, [variantvalues.productPhoto]);

    const getProductsBadges = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductBadges`, { app: 0 }, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    if (res.data.success === 1) {
                        setBadges(res.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(res.data.message, 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading)
                    showToast('Something went wrong ! please try again ', 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get suplliers, please try again later ", 'error');
        }
    }



     const getPackingMeasurement = async () => {

      
        
        StartLoading(setisLoading);
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getmeasurementlist`, { app: 0 }, { withCredentials: true })
            .then((res) => {
                if (res.data.success === 1) {
                    StopLoading(setisLoading)
                    showToast(res.data.message, 'success');
                    const transformedData = res.data.data.map(Measurement => ({
                        label: Measurement.measurement_name,
                        value: Measurement.id,
                    }));
                    // console.log({ transformedData: transformedData });
                    setmeasurementData(transformedData);
                    // setPackingtypeData(res.data.data);
                }
                else if (res.data.success === 0) {
                    StopLoading(setisLoading)
                    // showToast(res.data.message, 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);

                if (err.response && err.response.data && err.response.data.message) {
                    // API se jo message aaya he use show karo
                    // showToast(err.response.data.message, 'error');
                } else {
                    // agar kuch aur error ho (jaise network error)
                    showToast('Something went wrong! Please try later', 'error');
                }
            });
    };



    const getProductswarehouse = async () => {
        StartLoading(setisLoading);
        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/Getwarehouse`,
                { app: 0 },
                { withCredentials: true }
            );

            StopLoading(setisLoading);

            if (response.data?.success === 1) {
                setWarehouse(response.data.data);
            } else {
                showToast(response.data?.message || 'Operation failed', 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);

            // Handle different error cases
            if (err.response) {
                // The request was made and the server responded with a status code
                showToast(err.response.data?.message || 'Server responded with an error', 'error');
            } else if (err.request) {
                // The request was made but no response was received
                showToast('No response received from server', 'error');
            } else {
                // Something happened in setting up the request
                showToast('Request setup error: ' + err.message, 'error');
            }

            console.error('Error details:', err);
        }
    };

    // .........................................Intial Functions................................................
    const getProductDetails = async () => {
        StartLoading(setisLoading);
        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/Getproductdetails`,
                { product_unique_key: id },
                { withCredentials: true }
            );

            StopLoading(setisLoading);

            if (response.data.success === 1) {

                // Access the product data correctly from response.data.data
                const productData = response.data.data.product;

                setValues({
                    productCode: productData.Product_code || '',
                    productName: productData.product_name || '',
                    productTax: productData.tax || 0,
                    shortDescription: productData.product_short_description || '',
                    badgeName: productData.badge_name || 0,
                    warehouseName: productData.warehouse_name || 0,
                    badge: productData.badge_id || 0,
                    
                    warehouse: productData.warehouse_id || 0
                });

                setSelectedwarehouse({ label:productData.warehouse_name, value: productData.warehouse_id})
                setSelectedBadge({label:productData.badge_name, value: productData.badge_id})

                setProductcategoryString(response.data.data.categoryPath || '');
                setVariants(response.data.data.variants || '');
                setProductPhotos(response.data.data.images || '');
                setDocuments(response.data.data.documents || '');
                setOffresData(response.data.data.offers || '')

            } else {
                showToast(response.data.message || 'Failed to load product details', 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);

            if (err.response?.status === 401) {
                // Handle unauthorized
                // alert('Session expired. Please logout and login again.');
            } else {
                showToast(
                    err.response?.data?.message ||
                    err.message ||
                    'Failed to fetch product details',
                    'error'
                );
            }
            console.error('Error fetching product details:', err);
        }
    };


    useEffect(() => {
        getProductsBadges();
        getProductswarehouse();
        getPackingMeasurement();
    }, []);


    const stringtoarray = (return_array) => {
        setUserAttributesArray(return_array.split(','));
    }

    // ...........................................Product Details Functions..............................................

    const handleproductDetailsmodalshow = () => {
        setproductDetailsmodalshow(true);
        setVariantValue(prevValues => ({
            ...prevValues,
            visible: 0,
            active: 0,
        }));
    }
    const handleproductDetailsmodalhide = () => {
        setproductDetailsmodalshow(false);
    }
    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddProductDetailsForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const handleDetailsInputChange = e => {
        const { name, value } = e.target;
        setValues(prevValues => ({ ...prevValues, [name]: value }));
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
    };
    const handleBadgeChange = (selectedOption) => {
        // console.log({ selectedOption: selectedOption });
        setSelectedBadge(selectedOption);
        // console.log('Selected Badge:', selectedOption);
    };
    const handlewarehouseChange = (selectedOption) => {
        setSelectedwarehouse(selectedOption);
        console.log('Selected warehouse:', selectedOption);
    };

    const handleEditProductDetailsSubmit = (e) => {
        e.preventDefault();
        StartLoading(setisLoading);
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
            StopLoading(setisLoading)
            clearAllErrors();
            ProductDetailsSubmit();
        }
    }

    useEffect(() => {
        showToast('', '');
        if (disabledStatus.productVariant) {
            getUserAttributes();
            getPackingType();
        }
    }, [disabledStatus.productVariant]);

    const ProductDetailsSubmit = async () => {
        StartLoading(setisLoading);

        const product_name = values.productName;
        const product_code = values.productCode;
        const product_tax = values.productTax;
        const shortdescription = values.shortDescription;

        const ProductdBadgeID = selectedBadge?.value || 0;
        const productWarehouseID = selectedwarehouse?.value || 0;
        const product_unique_id = uniqueID;

        if (product_name !== '' && product_code !== '' && shortdescription !== '' && product_tax !== '' && product_unique_id !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditproductDetails`, { product_name, product_code, ProductdBadgeID, productWarehouseID, product_tax, product_unique_id, shortdescription, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        if (response.data.success === 1) {
                            showToast(response.data.message, 'success');
                            handleproductDetailsmodalhide();
                            getProductDetails()
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (err.status === 401) {
                            // alert('Logout');
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to update product details, please try again later ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast("Please Fill All Required Fileds ", 'error');
        }
    }



    // Product Category functions 
    const handleCategoryChange = async (index, selectedOption) => {
        // Copy the current selected categories
        const newSelectedCategories = [...selectedCategories];
        // console.log({ newSelectedCategories: newSelectedCategories });

        // Update the selected option for the current index
        newSelectedCategories[index] = selectedOption ? selectedOption.value : null;

        // Remove any categories after the current index (reset subsequent indices)
        for (let i = index + 1; i < newSelectedCategories.length; i++) {
            newSelectedCategories[i] = null;
        }

        // Filter out `null` values from the selected categories
        const filteredCategories = newSelectedCategories.filter(value => value !== null);

        // Set the filtered selected categories
        setSelectedCategories(filteredCategories);

        // Fetch sub-categories or next level options for the selected category
        if (selectedOption) {
            const categoryID = selectedOption.value;
            try {
                // Replace with your API for fetching next-level categories or sub-categories
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/GetCategories`,
                    { categoryID },
                    { withCredentials: true }
                );
                // console.log(response.data);

                // Check if the API response is successful and contains valid data
                if (response.data.success === 1 && Array.isArray(response.data.data) && response.data.data.length > 0) {
                    // Format the options if the response has subcategories
                    const formattedOptions = response.data.data.map(subCategory => ({
                        value: subCategory.id,
                        label: subCategory.name
                    }));

                    // Update category data to show subcategory select
                    setCategoryData(prevData => ({
                        ...prevData,
                        [index + 1]: formattedOptions // Dynamically add options for next select
                    }));
                } else {
                    // If no subcategories are found, show alert and do not add a new select
                    // showToast("No more categories found", 'error');

                    // Optionally clear the next select options if no subcategories
                    setCategoryData(prevData => ({ ...prevData, [index + 1]: [] }));
                }
            } catch (error) {
                console.error('Error fetching sub-categories:', error);
            }
        } else {
            // Clear options if no category is selected
            setCategoryData(prevData => ({
                ...prevData,
                [index + 1]: []
            }));
        }
    };
    // Product Categories 

    const handleproductCategorymodalshow = () => {
        setproductCategorymodalshow(true);
        getCategories(0);
    }
    const handleproductCategorymodalhide = () => {
        setproductCategorymodalshow(false);
    }

    const handleProductCategrySubmit = async (e) => {

        e.preventDefault();
        clearAllErrors();
        ProductCategoriesSubmit();
    }
    const ProductCategoriesSubmit = async () => {


        const product_ID = selectedCategories;
        const product_unique_id = uniqueID;

        if (product_ID !== '' && product_unique_id !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddproductCategory`, { product_ID, product_unique_id, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        if (response.data.success === 1) {
                            showToast(response.data.message, 'success');
                            setProductcategoryString(response.data.data.categoryPath || '');
                            handleproductCategorymodalhide();
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (err.status === 401) {
                            // alert('Logout');
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to Add product Category, please try again later ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast("Please Fill All Required Fileds ", 'error');
        }


    }

    const getCategories = async (categoryID) => {
        // console.log(categoryID);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCategories`, { categoryID, app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        const formattedCategories = response.data.data.map(category => ({
                            value: category.id,
                            label: category.name,
                        }));
                        setCategories(formattedCategories);

                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Get Categories, please try again later ", 'error');
        }
    };

    // Product Variant Functions 



    const getUserAttributes = () => {
        axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`, { app: 0 }, { withCredentials: true })
            .then((res) => {
                if (res.data.success === 1) {
                    const return_array = res.data.selectedArray[0]['selected_attributes_id'];
                    stringtoarray(return_array);
                }
                else if (res.data.success === 0) {
                    //   toast.error(res.data.message, {
                    //     position: "top-center",
                    //     autoClose: 2000,
                    //     hideProgressBar: true,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "colored",
                    //   });
                }
            })
            .catch((err) => { })
    }


    const getPackingType = async () => {
        StartLoading(setisLoading);
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetPackingtypes`, { app: 0 }, { withCredentials: true })
            .then((res) => {
                if (res.data.success === 1) {
                    StopLoading(setisLoading)
                    showToast(res.data.message, 'success');
                    const transformedData = res.data.data.map(Packingtype => ({
                        label: Packingtype.type_name,
                        value: Packingtype.id,
                    }));
                    // console.log({ transformedData: transformedData });
                    setPackingtypeData(transformedData);
                    // setPackingtypeData(res.data.data);
                }
                else if (res.data.success === 0) {
                    StopLoading(setisLoading)
                    showToast(res.data.message, 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading)
                showToast('something went wrong ! please try later', 'error');
            });
    };

    useEffect(() => {
        if (variantCount !== 0) {
            const timer = setTimeout(() => {
                GetproductVariants();
            }, 1000); // 2000 milliseconds = 2 seconds

            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [variantCount]);


    const handlevariationmodalshow = () => {

        setVariationmodalshow(true);
        getUserAttributes();
        getPackingType();
        setVariantValue(prevValues => ({
            ...prevValues,
            visible: 0,
            active: 0,
        }));
    }
    const handlevariationmodalhide = () => {
        setVariationmodalshow(false);
    }
    const handleSellingUnit = e => {
        var p = new RegExp(/^[0-9\b]+$/);
        const { name, value } = e.target;
        if (value === '' || p.test(value) || e.which !== 69) {
            setVariantValue({ ...variantvalues, [name]: value });
        }
    };
    const handleVariantInput = e => {
        const { name, value } = e.target;
        setVariantValue({ ...variantvalues, [name]: value });
    };

    const handlepackingtype = (result) => {
        // alert(result.value);
        setVariantValue(prevValues => ({
            ...prevValues,
            measurement: result.value,
        }));
    };

    const handleshippingpackingtype = (result) => {
        // alert(result.value);
        setVariantValue(prevValues => ({
            ...prevValues,
            shippingmeasurement: result.value,
        }));
    };

        const [variantError , setVariantError]=useState({})
 

    const handleEditvariantSave = async (e) => {
        e.preventDefault();
        StartLoading(setisLoading);


        const validationErrors = validateAddProductVariantForm(variantvalues);
                
           if (Object.keys(validationErrors).length > 0) {
               setVariantError(validationErrors);
               return;
            }

        console.log("ss");
        console.log(variantvalues);
        
        

        // try {
            const {
                id,
                sellingUnit,
                sellingUnitPackingType,
                measurement,
                shippingmeasurement,
                ShippingUnit,
                shippingUnitPackingType,
                productVariant,
                productHSN,
                productWarenty,
                productMOQ,
                productID,
                productMRP,
                productPrice,
                Link,
                // stock,
                productPhoto,
            } = variantvalues;

            console.log(id);
            console.log(uniqueID);
            

            // Create FormData and append all fields
            const formData = new FormData();
            formData.append('variantId', id);
            formData.append('ProductUniqueID', uniqueID);
            formData.append('sellingUnit', sellingUnit);
            formData.append('sellingUnitPackingType', sellingUnitPackingType);
            formData.append('Measurement', shippingMeasurement?.value || 'NA');

            formData.append('ShippingUnit', ShippingUnit);
            formData.append('shippingUnitPackingType', shippingUnitPackingType);
            formData.append('shippingmeasurement', sellingMeasurment?.value || 'NA');

            formData.append('ProductVariant', productVariant);
            formData.append('ProductID', productID);

            formData.append('ProductHSN', productHSN);
            formData.append('ProductWarranty', productWarenty);
            formData.append('ProductMOQ', productMOQ);
            formData.append('productMRP', productMRP);
            formData.append('ProductPrice', productPrice);

            formData.append('Link', Link || ''); // Handle possible undefined
            formData.append('Visible', isVariantVisible);
            formData.append('Active', isVariantActive);
            formData.append('app', 0);

            // Only append file if it exists
            if (productPhoto) {
                formData.append('ProductImage', productPhoto);
            }
            
            // Make the API call with proper headers
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/EditProductVariant`,
                  formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    // Add timeout to prevent hanging
                    timeout: 60000, // 30 seconds
                }
            );


         
            // Handle successful response
            StopLoading(setisLoading);
            //   console.log('Response data:', response.data);
            if (!response || !response.data) {
                throw new Error('Invalid server response structure');
            }

            if (response.data && response.data.success === 1) {


                setVariants(response.data.variants || '');
                setVariantValue({
                    sellingUnit: "",
                    sellingUnitPackingType: "",
                    shippingUnit: "",
                    shippingUnitPackingType: "",
                    productVariant: "",
                    productHSN: "",
                    productWarenty: "",
                    productMOQ: "",
                    productPhoto: null,
                });
                handleproductEditVariantmodalhide();


            } else {
                throw new Error(response.data?.message || 'Unknown server response');
            }


        // } catch (error) {
        //     StopLoading(setisLoading);

        //     // Enhanced error handling
        //     let errorMessage = 'Failed to add variant';

        //     if (error.response) {
        //         // Server responded with error status (4xx, 5xx)
        //         console.error('Server error:', error.response.status, error.response.data);
        //         errorMessage = error.response.data.message || `Server error: ${error.response.status}`;
        //     } else if (error.request) {
        //         // Request was made but no response received
        //         console.error('No response:', error.request);
        //         errorMessage = 'No response from server';
        //     } else if (error.message) {
        //         // Something happened in setting up the request
        //         console.error('Request setup error:', error.message);
        //         errorMessage = error.message;
        //     } else {
        //         console.error('Unknown error:', error);
        //     }

        //     showToast(errorMessage, 'error');
        // } finally {
        //     StopLoading(setisLoading);
        // }
    };
    const handleToggleVariantVisible = () => {
        setIsVariantVisible(!isVariantVisible);
        // console.log("Variant Visible:", !isVariantVisible);
    };

    const handleToggleVariantActive = () => {
        setIsVariantActive(!isVariantActive);
        // console.log("Variant Active:", !isVariantActive);
    };

    const handleEditVariant = (variant) => {
        console.log({ variant: variant })

        if(variants.length > 0){

              const measurement_filter = measurementdata.filter((measure)=> measure.value == variant.measurement)
        const measurement_filter_shipping = measurementdata.filter((measure)=> measure.value == variant.shippingmeasurement)

        if(measurement_filter?.length > 0){
          setShippingMeasurement({label:measurement_filter[0].label , value:measurement_filter[0].value})
        }

        if(measurement_filter_shipping?.length > 0){
            setSellingMeasurment({label:measurement_filter_shipping[0].label , value:measurement_filter_shipping[0].value})
        }


               setVariantValue({
            id: variant.id,
            sellingUnit: variant.sellingUnit,
            sellingUnitPackingType: variant.sellingUnitPackingType,
            ShippingUnit: variant.ShippingUnit,
            shippingUnitPackingType: variant.shippingUnitPackingType,
            productVariant: variant.productVariant,
            productHSN: variant.productHSN,
            productWarenty: variant.productWarenty,
            productMOQ: variant.productMOQ,
            productID: variant.productID,
            productMRP: variant.productMRP,
            productPrice: variant.productPrice,
            Link: variant.Link,
            measurement: measurement_filter[0]?.label,
            shippingmeasurement: measurement_filter_shipping[0]?.label,
            productPhoto: variant.productPhoto,
            visible: 0,
            active: 0,
        });

            
        }


        // setEditingVariant(variant);

        setproductEditVariantmodalshow(true)
        
      
    


        // Map the variant data to your form fields

 


        // handleproductEditVariantmodalshow()
        // getUserAttributes();
        // getPackingType();

    };

    const handleDeleteVariant = async (variantId) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteVariant`, { variantId, product_UID: uniqueID, app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    showToast(response.data.message, 'success');
                    if (response.data.success === 1) {
                        StopLoading(setisLoading)
                        setVariants(response.data.data || '');
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Delete Variant, please try again later ", 'error');
        }
    };


    const handleproductEditVariantmodalshow = () => {
        // console.log({ variants: variantvalues })
        setproductEditVariantmodalshow(true);
        // setVariantValue(prevValues => ({
        //     ...prevValues,
        //     visible: 0,
        //     active: 0,
        // }));
    }
    const handleproductEditVariantmodalhide = () => {
        setproductEditVariantmodalshow(false);
    }

    const handleVariantPhotoUpload = (e) => {
        const file = e.target.files[0];
        setVariantValue({ ...variantvalues, productPhoto: e.target.files[0] });
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setVariantImage({
                    file,
                    preview: reader.result,
                    existing: null
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveImage = () => {
        // If editing existing variant, mark image for deletion
        if (variantvalues.productPhoto) {
            setVariantImage({
                file: null,
                preview: null,
                existing: null
            });
            // You might want to track this to delete from server later
            setVariantValue(prev => ({ ...prev, productPhoto: null }));
        } else {
            // If new upload, just clear the selection
            setVariantImage({
                file: null,
                preview: null,
                existing: null
            });
        }
    };



    const handlevariantSave = async (e) => {
        e.preventDefault();
        StartLoading(setisLoading);

               const validationErrors = validateAddProductVariantForm(variantvalues);
                
           if (Object.keys(validationErrors).length > 0) {
               setVariantError(validationErrors);
               return;
            }
        

        // try {
            const {
                sellingUnit,
                sellingUnitPackingType,
                measurement,
                shippingmeasurement,
                ShippingUnit,
                shippingUnitPackingType,
                productVariant,
                productHSN,
                productWarenty,
                productMOQ,
                productID,
                productMRP,
                productPrice,
                Link,
                // stock,
                productPhoto,
            } = variantvalues;


            // Create FormData and append all fields
            const formData = new FormData();
            formData.append('ProductUniqueID', uniqueID);
            formData.append('sellingUnit', sellingUnit);
            formData.append('sellingUnitPackingType', sellingUnitPackingType);
            formData.append('Measurement', measurement);

            formData.append('ShippingUnit', ShippingUnit);
            formData.append('shippingUnitPackingType', shippingUnitPackingType);
            formData.append('shippingmeasurement', shippingmeasurement);

            formData.append('ProductVariant', productVariant);
            formData.append('ProductID', productID);

            formData.append('ProductHSN', productHSN);
            formData.append('ProductWarranty', productWarenty);
            formData.append('ProductMOQ', productMOQ);
            formData.append('productMRP', productMRP);
            formData.append('ProductPrice', productPrice);

            formData.append('Link', Link || ''); // Handle possible undefined
            formData.append('Visible', isVariantVisible);
            formData.append('Active', isVariantActive);
            formData.append('app', 0);

            // Only append file if it exists
            if (productPhoto) {
                formData.append('ProductImage', productPhoto);
            }

        
            // Make the API call with proper headers
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductVariant`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                   
                }
            );
            // Handle successful response
            StopLoading(setisLoading);
            //   console.log('Response data:', response.data);
            if (!response || !response.data) {
                throw new Error('Invalid server response structure');
            }

            if (response.data && response.data.success === 1) {

                // Update state only after confirmed success
                setVariants([...variants, variantvalues]);
                setVariantValue({
                    sellingUnit: "",
                    sellingUnitPackingType: "",
                    shippingUnit: "",
                    shippingUnitPackingType: "",
                    productVariant: "",
                    productHSN: "",
                    productWarenty: "",
                    productMOQ: "",
                    productPhoto: null,
                });

                handlevariationmodalhide();

            } else {
                throw new Error(response.data?.message || 'Unknown server response');
            }


        // } catch (error) {
        //     StopLoading(setisLoading);

        //     // Enhanced error handling
        //     let errorMessage = 'Failed to add variant';

        //     if (error.response) {
        //         // Server responded with error status (4xx, 5xx)
        //         console.error('Server error:', error.response.status, error.response.data);
        //         errorMessage = error.response.data.message || `Server error: ${error.response.status}`;
        //     } else if (error.request) {
        //         // Request was made but no response received
        //         console.error('No response:', error.request);
        //         errorMessage = 'No response from server';
        //     } else if (error.message) {
        //         // Something happened in setting up the request
        //         console.error('Request setup error:', error.message);
        //         errorMessage = error.message;
        //     } else {
        //         console.error('Unknown error:', error);
        //     }

        //     showToast(errorMessage, 'error');
        // } finally {
        //     StopLoading(setisLoading);
        // }
    };

    const [shippingSelected, setShippingSelected] = useState('');


    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [getVariant, setgetVariant] = useState([]);
    const [productPhotos, setProductPhotos] = useState([]);

    const [fileTitle, setFileTitle] = useState('');
    const [currentFile, setCurrentFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file.name.split('.').pop().toLowerCase();
            setCurrentFile({
                file,
                name: file.name,
                type: fileType
            });
        }
    };

    const getFileIcon = (fileName) => {
        if (!fileName || typeof fileName !== 'string') {
            return <FiFile className="text-gray-400 text-2xl" />; // Default icon for invalid or undefined file name
        }

        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'pdf':
                return <FaFilePdf className="text-red-500 text-2xl" />;
            case 'doc':
            case 'docx':
                return <FaFileWord className="text-blue-500 text-2xl" />;
            case 'ppt':
            case 'pptx':
                return <FaFilePowerpoint className="text-orange-500 text-2xl" />;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return <FiImage className="text-green-500 text-2xl" />;
            case 'txt':
                return <FiFileText className="text-gray-500 text-2xl" />;
            default:
                return <FiFile className="text-gray-400 text-2xl" />;
        }
    };


    const handleDownload = async (documentId) => {
        try {
            // Make the API call using axios
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/DownloadDoc/`,
                { documentId },
                {
                    responseType: 'blob', // Important to specify that we're expecting a blob
                    withCredentials: true,
                }
            );

            // Check if the response contains a valid blob (file download)
            const contentType = response.headers['content-type'];

            // Allow image content types or any valid blob
            if (!contentType.startsWith('image/') && !contentType.startsWith('application/')) {
                console.error('Download failed: Invalid content type', contentType);
                return;
            }

            // Get filename from headers (content-disposition)
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'document';
            if (contentDisposition) {
                const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
                filename = match ? decodeURIComponent(match[1]) : filename;
            }

            // Create a blob URL and trigger download
            const blob = response.data;
            const url = window.URL.createObjectURL(blob);

            // Create a link element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            a.download = filename; // Set the filename for the download
            document.body.appendChild(a);
            a.click();
            a.remove();

            // Clean up the blob URL after a short delay
            setTimeout(() => window.URL.revokeObjectURL(url), 100);

        } catch (error) {
            console.error('Error:', error);
        }
    };


    const handleDeleteDocs = async (documentId) => {
        if (window.confirm('Are you sure you want to delete this document?')) {
            try {
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/DeleteDocument`, { document_id: documentId, product_UID: uniqueID }, { withCredentials: true, }
                );
                StopLoading(setisLoading);
                if (!response || !response.data) {
                    throw new Error('Invalid server response structure');
                }
                if (response.data && response.data.success === 1) {
                    // console.log(response);
                    setDocuments(documents.filter(doc => doc.id !== documentId));
                    showToast('Document uploaded successfully!', 'success');
                } else {
                    throw new Error(response.data?.message || 'Unknown server response');
                }
                // alert('Document deleted successfully');

            } catch (error) {
                console.error('Delete failed:', error);
                // alert('Delete failed. Please try again.');
            }
        }
    };


    const handleAddDocument = async () => {
        // alert('add document call')
        if (!fileTitle.trim()) {
            showToast('Document title should not be empty!', 'error');
            return;
        }

        if (!currentFile) {
            showToast('Please select a file first!', 'error');
            return;
        }

        if (currentFile.size > 5 * 1024 * 1024) {
            const sizeInMB = (currentFile.size / (1024 * 1024)).toFixed(2);
            showToast(`Selected file is ${sizeInMB} MB. Max allowed size is 5 MB!`, 'error');
            return;
        }

        // Create a new file object with pending status
        const newFile = {
            title: fileTitle,
            name: currentFile.name,
            type: currentFile.type,
            file: currentFile,
            status: 'pending' // 'pending', 'uploading', 'uploaded', 'failed'
        };
        // console.log({ currentFile: currentFile });

        // Add to files list with 'uploading' status
        setUploadedFiles(prev => [
            ...prev,
            { ...newFile, status: 'uploading' }
        ]);
        const file = currentFile.file;
        // console.log(file);

        try {
            const formData = new FormData();
            formData.append("product_UID", uniqueID);
            formData.append("document_type", currentFile.type); // e.g. "image/png"
            formData.append('document', file); // Append the File object directly
            formData.append('document_title', fileTitle);
            formData.append('app', 0);

            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            StopLoading(setisLoading);
            //   console.log('Response data:', response.data);
            if (!response || !response.data) {
                throw new Error('Invalid server response structure');
            }

            if (response.data && response.data.success === 1) {

                // console.log(response);
                // Update the file status to 'uploaded'
                setUploadedFiles(prev => prev.map(file =>
                    file.name === newFile.name ? {
                        ...file,
                        status: 'uploaded',
                        data: response.data.data
                    } : file
                ));

                showToast('Document uploaded successfully!', 'success');


            } else {
                throw new Error(response.data?.message || 'Unknown server response');
            }


        } catch (err) {
            console.error('Upload error:', err);
            // Update the file status to 'failed'
            setUploadedFiles(prev => prev.map(file =>
                file.name === newFile.name ? { ...file, status: 'failed' } : file
            ));
            showToast('Failed to upload document', 'error');
        } finally {
            // Reset current file and title
            setCurrentFile(null);
            setFileTitle('');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    const handleUpload = async () => {
        // alert();
        if (!fileTitle.trim()) {
            showToast('Document title should not be empty!', 'error');
            return;
        }

        if (!currentFile) {
            showToast('Please select a file first!', 'error');
            return;
        }


        const formData = new FormData();
        formData.append("product_UID", uniqueID);
        formData.append("document_type", currentFile.type); // e.g. "image/png"
        formData.append('document', currentFile); // Append the File object directly
        formData.append('document_title', fileTitle);
        formData.append('app', 0);



        try {
            const res = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductdocs`,
                formData,
                { withCredentials: true }
            );

            // Add to uploaded files list
            setUploadedFiles(prev => [
                ...prev,
                {
                    title: fileTitle,
                    name: currentFile.name,
                    type: currentFile.type,
                    data: res.data.data // assuming the response contains some file data
                }
            ]);



            // Reset current file and title
            setCurrentFile(null);
            setFileTitle('');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            showToast('Document uploaded successfully!', 'success');
        } catch (err) {
            console.error('Upload error:', err);
            showToast('Failed to upload document, please try again later', 'error');
        }
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
        // You might also want to call an API to delete the file from the server
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };




    // Product Offers 
    const handleDocsSubmit = async () => {
        if (uploadedFiles.length === 0) {
            showToast('No documents to upload!', 'error');
            return;
        }
    };

    // console.log(variantvalues);
    const handleonchange = e => {
        setVariantValue({ ...variantvalues, fileImage: e.target.files[0] });
    };

    const handlevariantupdatesubmit = async (e) => {

        e.preventDefault();
        StartLoading(setisLoading);

        const { productSize, sellingUnit, sellingUnitPackingType, measurement, shippingmeasurement, ShippingUnit, shippingUnitPackingType, productVariant, productHSN, productWarenty, productMOQ, productID, productMRP, productPrice, Link, stock, fileImage, visible, active } = variantvalues;

        const formData = new FormData();
        formData.append("editvariantid", variantrowid);
        formData.append('ProductUniqueID', uniqueID);
        formData.append('ProductSize', productSize);
        formData.append('Measurement', measurement);
        formData.append('shippingmeasurement', shippingmeasurement);
        formData.append('sellingUnit', sellingUnit);
        formData.append('sellingUnitPackingType', sellingUnitPackingType);
        formData.append('ShippingUnit', ShippingUnit);
        formData.append('shippingUnitPackingType', shippingUnitPackingType);
        formData.append('ProductVariant', productVariant);
        formData.append('ProductHSN', productHSN);
        formData.append('ProductWarranty', productWarenty);
        formData.append('ProductMOQ', productMOQ);
        formData.append('ProductID', productID);
        formData.append('productMRP', productMRP);
        formData.append('ProductPrice', productPrice);
        formData.append('Link', Link);
        formData.append('Visible', visible);
        formData.append('Active', active);
        formData.append('ProductImage', fileImage);
        formData.append('app', 0);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UpdateProductVariant`, formData, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading);
                    // console.log(res.data.data);
                    // console.log(res.data.data.length);
                    setvariantCount(res.data.data.length);
                    handlevariationmodalhide();
                }).catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Update Product Variant, please try again later ", 'error');
        }
    };



    const GetproductVariants = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductVariant`, { productUinqueID: uniqueID, app: 0 }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        setisLoading(false);
                        setisDisabled(false);
                        // console.log(res.data.data);
                        setgetVariant(res.data.data);
                    }
                    else {
                        // setisData(false);
                        // toastifn(0, res.data.message);
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Get Product Variant , please try again later ", 'error');
        }
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const handleVariantEdit = async (productUinqueID) => {
        // alert(productUinqueID);

        StartLoading(setisLoading);
        getPackingType();


        if (productUinqueID !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetsingleVariantData`, { productUinqueID, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        StopLoading(setisLoading);
                        // console.log(response.data.data);
                        if (response.data.success === 1) {
                            // Accessing the first item of the 'data' array
                            var product = response.data.data[0];

                            // Calling the modal show function
                            handlevariationmodalshow();
                            setEditvariantrowid(productUinqueID);
                            // Setting the variant values using the extracted data
                            setVariantValue({
                                sellingUnit: product.selling_unit,
                                sellingUnitPackingType: product.selling_unit_packing_type,
                                measurement: 0, // This should be updated if needed
                                ShippingUnit: product.shipping_unit,
                                shippingUnitPackingType: product.shipping_unit_packing_type,
                                shippingmeasurement: 0, // This should be updated if needed
                                productVariant: product.product_variant,
                                productHSN: product.product_hsn_code,
                                productWarenty: product.product_warrenty,
                                productOU: product.product_id,
                                productMOQ: product.minimum_order_quantity,
                                productID: product.product_id,
                                productMRP: product.product_mrp,
                                productPrice: product.product_price,
                                Link: product.product_link,
                                Stock: product.product_stock,
                                fileImage: product.product_variant_image,
                                visible: product.is_visible,
                                active: product.status, // Assuming status indicates whether it's active
                            });
                        }
                        else {
                            StopLoading(setisLoading);
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        StopLoading(setisLoading);
                        showToast('Something went wrong ! please try again ', 'error');
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast("Something went wrong, please try again again ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast("Variant not selected. Try again. ", 'error');
        }
    }
    const [selectedColumns, setSelectedColumns] = useState(['product_variant_image', 'product_variant',]);
    const allColumns = ['id', 'product_variant_image', 'selling_unit', 'selling_unit_packing_type', 'shipping_unit', 'shipping_unit_packing_type', 'product_variant', 'product_hsn_code', 'product_warrenty', 'minimum_order_quantity', 'product_id', 'product_mrp', 'product_price', 'product_link', 'product_stock'];
    const [columnWidths, setColumnWidths] = useState({

        product_variant_image: 100,
        selling_unit: 50,
        selling_unit_packing_type: 50,
        shipping_unit: 50,
        shipping_unit_packing_type: 50,
        product_variant: 100,
        product_hsn_code: 50,
        product_warrenty: 50,
        minimum_order_quantity: 50,
        product_id: 50,
        product_mrp: 50,
        product_price: 50,
        product_link: 100,
        product_stock: 50,
    });
    // const tableRef = useRef(null);
    const toggleColumn = (column) => {
        setSelectedColumns((prev) =>
            prev.includes(column)
                ? prev.filter((col) => col !== column)
                : [...prev, column]
        );
    };
    const handleMouseDown = (col) => (e) => {
        e.preventDefault();
        const startX = e.clientX;

        const handleMouseMove = (moveEvent) => {
            const newWidth = Math.max(columnWidths[col] + (moveEvent.clientX - startX), 50); // Minimum width
            setColumnWidths((prev) => ({ ...prev, [col]: newWidth }));
        };

        const handleMouseUp = () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    };

    const handleDeletePhoto = async (id) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Deleteproductimage`, { photoID: id, product_UID: uniqueID, app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        showToast(response.data.message, 'success');
                        setProductPhotos(response.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    if (err.status === 401) {
                        // alert('Logout');
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Delete product image, please try again later ", 'error');
        }

    }
    const [filePreviews, setFilePreviews] = useState([]); // Store file previews (URLs)
    // const [uploadedImages, setUploadedImages] = useState([]); // Store uploaded image paths
    const [uploadingStatus, setUploadingStatus] = useState(""); // To show uploading status
    const [photoerror, setPhotoError] = useState(""); // To store errors
    const [isUploading, setIsUploading] = useState(false); // To control the upload button
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        multiple: true,
        maxFiles: 10,  // Limit to 10 files
        onDrop: (files) => {
            setPhotoError('');
            const previews = files.map((file) => ({
                file,
                preview: URL.createObjectURL(file), // Create a preview URL for each image
            }));
            setFilePreviews((prev) => [...prev, ...previews]);
        },
    });
    // Handle image upload
    const handleProductPhotoSubmit = async (e) => {
        e.preventDefault();
        StartLoading(setisLoading);

        if (acceptedFiles.length === 0) {
            StopLoading(setisLoading);
            showToast("Please select images to upload ", 'error');
            setPhotoError("Please select images to upload.");
            return;
        }

        setIsUploading(true);
        setUploadingStatus(`Uploading ${acceptedFiles.length} image(s)...`);

        const formData = new FormData();
        formData.append('unique_key', uniqueID);
        acceptedFiles.forEach((file) => {
            formData.append('productImage', file);
        });

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UploadProductImage`, formData, { withCredentials: true }).then((response) => {
                StopLoading(setisLoading);
                if (response.data.success === 1) {
                    showToast(response.data.message, 'success');
                    // setUploadedImages(response.data.files); // Store uploaded file paths
                    // setUploadingStatus(`${response.data.files.length} image(s) uploaded successfully.`);
                    setIsUploading(false);

                }
                else {
                    StopLoading(setisLoading);
                    showToast(response.data.message, 'error');
                }
            })
        } catch (err) {
            console.error("Error uploading files:", err);
            setPhotoError("Failed to upload images.");
            setUploadingStatus("");
            setIsUploading(false);
        }
        // console.log({ isDisabled: isDisabled });
    };

    // Remove image from preview list
    const handleRemovePreview = (fileToRemove) => {
        setFilePreviews((prev) => prev.filter(({ file }) => file !== fileToRemove));
    };


    // Product Offers 

    const [offermodalshow, setOffermodalshow] = useState(false);
    const [offerdata, setOfferData] = useState([{ offers: "" }]);
    const [offers, setOffers] = useState([]);
    // PRoduct Short Description
    const [shortdesc, setShortDescription] = useState('');
    const [longdesc, setLongDescription] = useState('');
    const handleofferChange = (e, i) => {
        const { name, value } = e.target
        const onchangeVal = [...offerdata]
        onchangeVal[i][name] = value
        setOfferData(onchangeVal);
    }
    const handleoffermodalshow = () => {
        setOffermodalshow(true);
    }
    const handleoffermodalhide = () => {
        setOffermodalshow(false);
    }
    
    const handleofferssubmit = async (e) => {
        StartLoading(setisLoading);
        e.preventDefault();

        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Addproductoffers`, { data: { uniqueID, offerdata } }, { withCredentials: true })
                .then((res) => {
                    var result = JSON.parse(JSON.stringify(res));
                    // console.log({ result: result });
                    if (result.data.success === 1) {

                        handleoffermodalhide();
                        StopLoading(setisLoading);
                        
                        getProductDetails();
                        setOffers(Array.isArray(result.data.data) ? result.data.data : [result.data.data]);

                    }
                    else {
                        StopLoading(setisLoading);
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to Add offer, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Add offer, please try again later ", 'error');
        }

    }
    const handleofferDelete = (i) => {
        const deleteVal = [...offerdata]
        deleteVal.splice(i, 1)
        setOfferData(deleteVal)
    }
    const handleofferClick = () => {
        setOfferData([...offerdata, { offers: "" }])
    }
    const offerscolumns = [
        {
            name: "Offer Details",
            width: '300px',
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            selector: (row) => row.product_offers,
        },
    ]



    //   Short Description 
    const handleshortdescChange = (e, editor) => {
        const shortDescriptiondata = editor.getData();
        setShortDescription(shortDescriptiondata);
    }


    const handleshortDescriptionsSubmit = async (e) => {
        e.preventDefault();
        const short_desc_data = shortdesc;
        StartLoading(setisLoading);
        const data = { uniqueID, short_desc_data };
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductShortDescriptions`, { data: data }, { withCredentials: true })
            .then((res) => {
                var result = JSON.parse(JSON.stringify(res));
                if (result.data.success === 1) {

                    // redirectviewproduct();
                }
                else {

                    StopLoading(setisLoading);
                    showToast("Failed to Add short description, please try again later ", 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);
                showToast("Failed to Add short description, please try again later ", 'error');
            });
        // }
    }

    //   Long Description 
    const handlelongdescChange = (e, editor) => {
        const longDescriptiondata = editor.getData();
        setLongDescription(longDescriptiondata);
    }
    const handlelongDescriptionsSubmit = async (e) => {
        e.preventDefault();
        const long_desc_data = longdesc;
        StartLoading(setisLoading);
        const data = { uniqueID, long_desc_data };
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddProductLongDescriptions`, { data: data }, { withCredentials: true })
            .then((res) => {
                var result = JSON.parse(JSON.stringify(res));
                if (result.data.success === 1) {

                    // redirectviewproduct();
                }
                else {

                    StopLoading(setisLoading);
                    showToast("Failed to Add short description, please try again later ", 'error');
                }
            })
            .catch((err) => {
                StopLoading(setisLoading);
                showToast("Failed to Add short description, please try again later ", 'error');
            });
        // }
    }

    // ================ New changes ==================//

    const [formOffer, setFormOffer] = useState({ id: 0, offer: "" })
    const handleOfferEditFilter = (rowId) => {
        setOfferOpen(true);
        const offer_filter = offersData.filter((offer) => offer.id === rowId);
        if (offer_filter.length > 0) {
            setFormOffer({ ...formOffer, id: rowId, offer: offer_filter[0]["product_offers"] });
        }
    }

    const handleOfferChange = (e) => {
        const { name, value } = e.target;
        setFormOffer({ ...formOffer, [name]: value })
    }

    const handleEditOfferSubmit = async (e) => {
        e.preventDefault();

        if (formOffer.id !== 0 && formOffer.offer !== "") {

            StartLoading(setisLoading);

            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditProductOffers`, { data: formOffer }, { withCredentials: true })
                .then((res) => {
                    var result = JSON.parse(JSON.stringify(res));
                    if (result.data.success === 1) {
                        handleOfferModalClose();
                        setFormOffer({ id: 0, offer: "" });
                        getProductDetails();
                        setOfferData([]);
                        // redirectviewproduct();
                    }
                    else {

                        StopLoading(setisLoading);
                        showToast("Failed to Add short description, please try again later ", 'error');
                    }
                })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to Add short description, please try again later ", 'error');
                });

        }
        else {
            showToast("Offer Field Missing !!!", 'error')
        }
    }


    const handleDeleteOffers = async (offerId) => {
        if (window.confirm('Are you sure you want to delete this document?')) {
            try {
                const response = await axiosJWT.post(
                    `${process.env.REACT_APP_API_URL}/api/DeleteProductOffers`, { offerId: offerId }, { withCredentials: true, }
                );
                StopLoading(setisLoading);
                if (!response || !response.data) {
                    throw new Error('Invalid server response structure');
                }
                if (response.data && response.data.success === 1) {
                    getProductDetails();
                    setOfferData([]);
                    showToast('Document uploaded successfully!', 'success');
                } else {
                    throw new Error(response.data?.message || 'Unknown server response');
                }
                // alert('Document deleted successfully');

            } catch (error) {
                console.error('Delete failed:', error);
                // alert('Delete failed. Please try again.');
            }
        }
    };


// setproductEditVariantmodalshow

    return {
        users,userPlan,Remainuser,subUser, productcategoryString, handlevariationmodalshow, variantvalues, variationmodalShow, handlevariationmodalhide, userAttributesarray, handleSellingUnit, packingtype, setPackingtype, packingtypeSelected, setPackingtypeSelected, measurementinputValue, setMeasurementInputValue, packingtypedata, packingtypeinputValue, handlepackingtype, shippingpackingtype, setShippingPackingtype, shippingpackingtypeSelected, setShippingPackingtypeSelected, shippingmeasurementinputValue, setShippingMeasurementInputValue, shippingSelected, handleshippingpackingtype, handleonchange, handlevariantupdatesubmit, toggleDropdown, isDropdownOpen, selectedColumns, columnWidths, allColumns, toggleColumn, handleMouseDown, getVariant, filePreviews, uploadingStatus, photoerror, isUploading, getInputProps, getRootProps, handleRemovePreview, handleProductPhotoSubmit, handleoffermodalshow, handleoffermodalhide, offermodalshow, handleofferssubmit, offerdata, handleofferChange, handleofferDelete, handleofferClick, offerscolumns, handleshortdescChange, shortdesc, offers, handleshortDescriptionsSubmit, handlelongdescChange, handlelongDescriptionsSubmit, longdesc, setLongDescription, handleVariantEdit, productPhotos, handleDeletePhoto,
        values, setValues, badges, setBadges, warehouse, setWarehouse, selectedBadge, setSelectedBadge, selectedwarehouse, setSelectedwarehouse, categories, selectedCategories, categoryData, handleCategoryChange, handleProductCategrySubmit, variants, handleVariantInput, handleVariantPhotoUpload, handleRemoveImage, handleEditvariantSave, handlevariantSave, handleToggleVariantVisible, handleToggleVariantActive,

        productDetailsmodalShow, handleproductDetailsmodalshow, handleproductDetailsmodalhide, handleDetailsInputChange, handleBadgeChange, handlewarehouseChange, handleproductCategorymodalshow, handleproductCategorymodalhide, productCategorymodalShow, setproductCategorymodalshow, handleEditVariant, handleDeleteVariant, handleproductEditVariantmodalshow, handleproductEditVariantmodalhide, productEditVariantmodalShow, fileTitle, setFileTitle, currentFile, setCurrentFile, uploadedFiles, handleFileChange, handleAddDocument, handleUpload, removeFile, triggerFileInput, fileInputRef, handleDocsSubmit, documents,
        handleEditProductDetailsSubmit, variantImage, setVariantImage, getFileIcon, handleDeleteDocs, handleDownload, offersData, setOfferOpen, offerOpen, handleOfferModalClose, handleOfferEditFilter, setFormOffer, formOffer, handleOfferChange, handleEditOfferSubmit, handleDeleteOffers ,  measurementdata , shippingMeasurement ,setShippingMeasurement , sellingMeasurment , setSellingMeasurment , variantError

    }
}

export default MidEditProducts